'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var cursor = 'pointer',
        appearanceMargin = theme.appearanceMargin;

    if (this.props.checked) {
        theme.color = theme.checkedColor;
    }

    if (this.props.disabled) {
        cursor = 'not-allowed';
        theme.color = theme.disabledColor;
        theme.hoverColor = theme.disabledColor;
    }

    if (this.props.error) {
        theme.color = theme.errorColor;
    }

    if (!this.props.children && !this.props.label) {
        appearanceMargin = 0;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            fontFamily: theme.fontFamily,
            display: 'inline-block'
        },
        field: {
            display: 'none'
        },
        label: {
            transition: 'all ' + theme.transitionDuration + ' ' + theme.transitionFunction,
            color: theme.color,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            width: '100%',
            cursor: cursor,

            '&:hover': {
                color: theme.hoverColor
            }
        },
        labelText: {
            paddingTop: theme.paddingTop,
            paddingBottom: theme.paddingBottom,
            paddingLeft: theme.paddingLeft,
            paddingRight: theme.paddingRight,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            textAlign: 'left',
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        iconWrapper: {
            margin: appearanceMargin,
            flexBasis: '24px',
            flexShrink: 0
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        labelText: (0, _aphroditeJss.css)(styleList.labelText),
        label: (0, _aphroditeJss.css)(styleList.label),
        field: (0, _aphroditeJss.css)(styleList.field),
        iconWrapper: (0, _aphroditeJss.css)(styleList.iconWrapper)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        fontSize: theme.tsNormal,
        fontFamily: theme.fontFamily,
        lineHeight: 1.5,
        color: theme.tLabel,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        appearanceMargin: '0 ' + theme.gutter * 2 + 'px 0 0',

        checkedColor: theme.tFilled,

        hoverColor: theme.tActive,

        disabledColor: theme.tDisabled,

        errorColor: theme.tError
    };
};